export default "__VITE_ASSET__CHyJX43S__"